import React from 'react';

const NotFound = () => {
  console.log('Not found page loading...');
  return <div>Page not found...</div>;
};

export default NotFound;
